import { BaseModel } from '../../base/base-model';
import { IAction } from '../../base/interfaces/action';
import { EA_DOCU_ACTIONS } from './ea-documentation.acl';
import { IJsonEADocumentation } from './interfaces/json.ea-documentation.interface';

export interface EaDocumentationModel extends IJsonEADocumentation {}

export class EaDocumentationModel extends BaseModel {
  constructor(obj: Partial<IJsonEADocumentation>) {
    super(obj);
  }

  override validateChange(path: string | symbol): boolean {
    return true;
  }

  override get getPossibleRowActions(): IAction[] {
    return EA_DOCU_ACTIONS.filter((a) => a.types.includes('row'));
  }

  override get getPossibleActions(): IAction[] {
    return EA_DOCU_ACTIONS;
  }
}
